<template>
	<div class="flex items-center">
		<input
			type="radio"
			class="cursor-pointer hover:border-gray-500"
			:id="inputId"
			v-model="val"
			:value="radioValue"
			:key="val"
			:name="name"
			:class="[
				'focus:ring-orange-500 h-5 w-5 text-orange-500',
				markInputInvalid ? 'border-red-500' : 'border-gray-300',
			]"
		/>

		<label
			:for="inputId"
			:class="[
				isWhite
					? 'pl-3 block text-white-700 cursor-pointer'
					: 'pl-3 block text-gray-700 cursor-pointer',
			]"
		>
			<slot>{{ __(label) }}</slot>
			<ui-tooltip
				v-if="tooltipText"
				class="text-green-400 whitespace-normal"
				:icon-stroke-width="2"
				icon-class="ml-1 w-4 h-4"
				:text="__(tooltipText)"
			/>
		</label>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			required: true,
		},
		form: {
			type: Object,
			required: false,
		},
		field: {
			type: String,
			required: false,
		},
		name: {
			required: true,
		},
		radioValue: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: false,
		},
		tooltipText: {
			type: String,
			default: "",
		},
		isWhite: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			val: this.value,
			originalVal: this.value,
		};
	},
	computed: {
		inputId() {
			return "input-" + this._uid;
		},
		hasForm() {
			return this.form && this.field;
		},
		markInvalid() {
			if (this.hasForm) {
				return this.form.hasErrors && this.form.errors[this.field] != null;
			} else {
				return false;
			}
		},
		markInputInvalid() {
			return this.markInvalid && this.val == this.originalVal;
		},
	},
	watch: {
		val(v) {
			this.$emit("input", v);
			this.$emit("change", v);
		},
	},
	methods: {
		validationEventListener() {
			if (this.hasForm) {
				let that = this;
				console.log(
					"is-mark-invalid",
					that.field,
					that.markInvalid,
					that.mounted
				);
				that.$bus.$emit("is-mark-invalid", that.field, that.markInvalid);
			}
		},
	},
	created() {
		this.$bus.$on("poll-is-mark-invalid", this.validationEventListener);
	},
	beforeDestroy() {
		console.log("TURNING OFF", this.field);
		this.$bus.$off("poll-is-mark-invalid", this.validationEventListener);
	},
};
</script>
